import request from '@/utils/request'

// 顶级分类列表
export function typeList (data) {
  return request({
    url: '/course/course/type_list',
    method: 'post',
    data
  })
}

// 获取课程分类列表
export function categoryList (data) {
  return request({
    url: '/course/course/category_list',
    method: 'post',
    data
  })
}

// 获取课程列表（列表项含 type_list: [1]单词 [2]句子）
export function courseList (data) {
  return request({
    url: '/course/course/course_list',
    method: 'post',
    data
  })
}

/**
 * 获取课程详情（POST /course/course/course_detail）
 * - chapter_type: 1单词 2句子，不传查全部；data 含 type_list: [1]|[2]|[1,2]
 * - list[*].is_free_learn：1 可免费学习 / 0 需开通 VIP
 */
export function courseDetail (data) {
  return request({
    url: '/course/course/course_detail',
    method: 'post',
    data
  })
}

/**
 * 获取课程题目列表（POST /course/course/question_list）
 * - 章节练习：chapter_id、可选 chapter_type；响应含 last_mode_type、mode_questions
 * - 学习计划混合复习：course_id + review_mode=1（勿传 chapter_id / task_mode）；按 data.content 原序；空 content 表示今日已完成
 * - V2 可读开关打开时，单题可能多 structure_status、tokens（及 split_data[].tokens）；前端消费见 config/questionV2Tokens.js
 */
export function questionList (data) {
  return request({
    url: '/course/course/question_list',
    method: 'post',
    data
  })
}

// 提交错题（question_id:当前题id remark:备注）
export function submitError (data) {
  return request({
    url: '/course/course/submit_error',
    method: 'post',
    data
  })
}

// 添加学习时间
export function addTime (data) {
  return request({
    url: '/course/course/add_time',
    method: 'post',
    data
  })
}

// 完成章节
export function finishChapter (data) {
  return request({
    url: '/course/course/finish_chapter',
    method: 'post',
    data
  })
}

/**
 * 提交答案（POST /course/course/submit_answer，参数: question_id、type 对错1/2、answer、question_type；
 * is_show_answer 提交时是否已打开答案弹窗 1/0；
 * 章节练习建议带 mode_type；计划复习有 attempt_id 则原样回传、勿带 mode_type；字段合法性由后端校验）
 */
export function submitAnswer (data) {
  return request({
    url: '/course/course/submit_answer',
    method: 'post',
    data
  })
}

/**
 * 章节模式切换记录（POST /course/course/mode_switch，参数: chapter_id、type 切出模式 1~20）
 * 失败可忽略，不影响前端切模式交互
 */
export function modeSwitch (data) {
  return request({
    url: '/course/course/mode_switch',
    method: 'post',
    data
  })
}

// 口语评测 warrant_id（body 可为空对象）
export function speakingEvalWarrant (data) {
  return request({
    url: '/course/course/evaluation',
    method: 'post',
    data: data || {}
  })
}

// 口语评测提交前积分校验（返回 data=1 表示可继续）
export function spokenCreditCheck (data) {
  return request({
    url: '/course/course/spoken',
    method: 'post',
    data: data || {}
  })
}

/** 腾讯智聆：获取 WebSocket 连接参数（POST /course/soe/connect_params） */
export function soeConnectParams (data) {
  return request({
    url: '/course/soe/connect_params',
    method: 'post',
    data: data || {}
  })
}

/** 腾讯智聆：保存评测结果（POST /course/soe/save_result；form: en、voice_id、result） */
export function soeSaveResult (data) {
  const params = new URLSearchParams()
  Object.entries(data || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    params.append(key, String(value))
  })
  return request({
    url: '/course/soe/save_result',
    method: 'post',
    data: params.toString(),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 我的课程列表（原收藏；列表项含 type_list: [1]单词 [2]句子）
export function collectList (data) {
  return request({
    url: '/course/collect/collect_list',
    method: 'post',
    data
  })
}

// 加入/取消我的课程（原收藏接口）
export function collectAdd (data) {
  return request({
    url: '/course/collect/collect_add',
    method: 'post',
    data
  })
}

// 查单词搜索
export function wordLookup (data) {
  return request({
    url: '/course/course/word',
    method: 'post',
    data
  })
}

// 探索单词列表（POST /course/course/word_list，参数: page、page_size）
export function wordList (data) {
  return request({
    url: '/course/course/word_list',
    method: 'post',
    data: data || {}
  })
}
